import styled from "styled-components";

const StyledSpan = styled.span`
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

const TextWithLinks = ({ text }) => {
  const replaceLinksWithTags = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;

    const parts = text.split(urlRegex);

    const handleLinkClick = (url) => {
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "https://" + url;
      }
      //window.location.href = url;
      window.open(url, "_blank");
    };

    const elements = parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <StyledSpan key={index} onClick={() => handleLinkClick(part)}>
            {part}
          </StyledSpan>
        );
      } else {
        return <span key={index}>{part}</span>;
      }
    });

    return elements;
  };

  return <div>{replaceLinksWithTags(text)}</div>;
};

export default TextWithLinks;
